import { useTranslations } from '@vocab/react';
import {
  Box,
  Heading,
  Inline,
  Stack,
  Text,
  TextLinkButton,
} from 'braid-design-system';

import type { Job } from 'src/__generated__/graphql';
import { StartOfContentTarget } from 'src/modules/ScreenReader/StartOfContentTarget';

import translations from '../.vocab';

import * as styles from './advertiser-logo.css';

interface Props {
  onClick?: () => void;
  jobDetails: Pick<Job, 'title' | 'advertiser' | 'products'>;
}

const PageTitle = ({ onClick, jobDetails }: Props) => {
  const { t } = useTranslations(translations);

  const logo = jobDetails.products?.branding ? (
    <Box
      borderRadius="large"
      boxShadow="borderNeutralLight"
      display="flex"
      alignItems="center"
      justifyContent="center"
      padding="xxsmall"
      className={styles.logoContainer}
    >
      <img
        src={jobDetails.products.branding.logo.url}
        className={styles.logo}
        alt={jobDetails.advertiser.name}
      />
    </Box>
  ) : null;

  return (
    <StartOfContentTarget>
      <Box paddingTop="large" paddingBottom="xlarge">
        <Inline space="gutter" alignY="center" collapseBelow="tablet">
          {logo}
          <Stack space="medium">
            <Text size="small" tone="secondary">
              {t('Applying for')}
            </Text>
            <Heading level="2" component="h1">
              {jobDetails.title}
            </Heading>
            <Text size="large">{jobDetails.advertiser.name}</Text>
            <Text size="small">
              <TextLinkButton hitArea="large" onClick={onClick}>
                {t('View job description')}
              </TextLinkButton>
            </Text>
          </Stack>
        </Inline>
      </Box>
    </StartOfContentTarget>
  );
};

export default PageTitle;
